module.exports = __webpack_public_path__ + "img/language.f629e214.svg";